import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  {
    q: "Comment fonctionne l'essai gratuit de 14 jours ?",
    a: "Inscrivez-vous gratuitement, sans carte bancaire, puis choisissez « Création manuelle » dans votre espace compte. Votre essai de 14 jours démarre à la création de votre boutique et vous donne accès au tableau de bord.",
  },
  {
    q: "Dois-je fournir une carte bancaire pour l'essai ?",
    a: "Non. Aucune carte bancaire n'est demandée pour l'inscription ni pour démarrer l'essai gratuit de 14 jours de la création manuelle.",
  },
  {
    q: "La Boutique IA est-elle incluse dans l'essai gratuit ?",
    a: "Non. La Boutique IA est une offre payante distincte : le paiement est demandé avant que l'IA génère votre boutique.",
  },
  {
    q: "Dans quelle devise sont affichés les prix ?",
    a: "Pour le parcours Boutique IA, les frais uniques de création et l'abonnement mensuel Sokoby sont facturés dans la devise de votre pays : dollars canadiens (CAD) au Canada, livres sterling (GBP) au Royaume-Uni, euros (EUR) dans les pays couverts de la zone euro et dollars américains (USD) ailleurs ou si le pays ne peut pas être déterminé. La devise et les montants localisés sont déterminés automatiquement côté serveur, jamais choisis par le navigateur. Les prix affichés reprennent ces montants. Les deux paiements sont séparés ; l'abonnement reprend la devise des frais de création déjà payés. Les abonnements des boutiques, distincts de cet abonnement Sokoby, restent facturés en USD.",
  },
];

export function PricingFAQ() {
  return (
    <section className="max-w-3xl mx-auto mt-20">
      <h2 className="text-3xl font-bold text-center mb-8">Questions fréquentes</h2>
      <Accordion type="single" collapsible>
        {faqs.map((f, i) => (
          <AccordionItem key={i} value={`faq-${i}`}>
            <AccordionTrigger className="text-left">{f.q}</AccordionTrigger>
            <AccordionContent className="text-muted-foreground">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
